(() => {
  if (customElements.get('oy-welcome-gift')) return;
  customElements.define('oy-welcome-gift', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) this._controller.abort();
      this._controller = new AbortController();
      const params = new URLSearchParams(window.location.search);
      const campaign = (params.get('offer') || params.get('campaign') || '').toLowerCase();
      const giftpro = (params.get('giftpro') || '').toLowerCase();
      const enewton = giftpro === 'a426eb88391a' || campaign === 'enewton' || campaign === 'a';
      const oy = giftpro === '0a5e704da8a9' || campaign === 'oy' || campaign === 'b';
      const shop = this.querySelector('[data-gwp-shop]');
      if (shop) {
        const destination = enewton ? this.dataset.enewtonUrl : this.dataset.oyUrl;
        const target = new URL(destination, window.location.origin);
        if (giftpro === 'a426eb88391a' || giftpro === '0a5e704da8a9') target.searchParams.set('giftpro', giftpro);
        shop.href = target.pathname + target.search + target.hash;
        shop.textContent = enewton ? 'Shop enewton & unlock my gift' : 'Shop & unlock my gift';
      }
      const offer = this.querySelector('[data-gwp-offer-copy]');
      const step = this.querySelector('[data-gwp-step-copy]');
      if (enewton) {
        if (offer) offer.textContent = 'Shop $125 or more in qualifying enewton merchandise and choose one of the selected bracelets as our gift to you.';
        if (step) step.textContent = 'Reach $125 in qualifying enewton merchandise.';
      } else if (oy) {
        if (offer) offer.textContent = 'Shop $125 or more in qualifying Occasionally Yours merchandise and choose one of the selected bracelets as our gift to you.';
        if (step) step.textContent = 'Reach $125 in qualifying Occasionally Yours merchandise.';
      }
      const note = this.querySelector('[data-gwp-mode-note]');
      if (note && (enewton || oy)) note.textContent = 'Your private offer must be activated by the campaign link in your mailer. Gift eligibility is confirmed in your cart.';
      const input = this.querySelector('[data-gwp-total]');
      if (!input) return;
      const progress = this.querySelector('[data-gwp-progress]');
      const status = this.querySelector('[data-gwp-status]');
      const update = () => {
        const amount = Number(input.value);
        if (input.value === '' || !Number.isFinite(amount) || amount < 0 || !input.validity.valid) {
          progress.value = 0;
          status.textContent = 'Enter a valid qualifying merchandise total between $0 and $10,000.';
          return;
        }
        const cents = Math.round(amount * 100);
        progress.value = Math.min(cents / 100, 125);
        status.textContent = cents >= 12500
          ? 'Your gift is unlocked! Choose one eligible enewton bracelet in your cart.'
          : 'You’re ' + new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((12500 - cents) / 100) + ' away from your complimentary bracelet.';
      };
      input.addEventListener('input', update, { signal: this._controller.signal });
      this.querySelectorAll('[data-gwp-amount]').forEach(button => button.addEventListener('click', () => {
        input.value = button.dataset.gwpAmount;
        update();
      }, { signal: this._controller.signal }));
      update();
    }
    disconnectedCallback() { if (this._controller) this._controller.abort(); }
  });
})();